module.exports = __webpack_public_path__ + "img/article-icon-101.cf714adc.svg";